import request from '@/utils/request'

let ElasticsearchApi = {

  /*设置详情*/
  esDetail(data) {
    return request._get('/shop/plus.elasticsearch.elasticsearch/index', data);
  },
  /*保存设置*/
  editConfig(data) {
    return request._post('/shop/plus.elasticsearch.elasticsearch/setEsConfig', data);
  },

  /*一键同步*/
  oneClickSync(data) {
    return request._post('/shop/plus.elasticsearch.elasticsearch/syncData', data);
  },
}

export default ElasticsearchApi;



// WEBPACK FOOTER //
// ./src/api/elasticsearch.js